module.exports = __webpack_public_path__ + "media/images/aloe/icons/checkout/tram-d2f9916038ec1cd20d277cf0c43ed963.svg";